import { SectionCode } from "../enum";

export const SECTION_NAMES: Record<string, string> = {
    [SectionCode.TextilHogar]: "Textil Hogar",
    [SectionCode.Ferreteria]: "Ferretería",
    [SectionCode.MenajeYDeco]: "Menaje y Deco",
    [SectionCode.Outdoor]: "Outdoor",
    [SectionCode.ElectroHogar]: "Electro Hogar",
    [SectionCode.BañosYCocinas]: "Baños y Cocinas",
    [SectionCode.Construccion]: "Materiales de construcción",
    [SectionCode.Herramientas]: "Herramientas",
    [SectionCode.Automotor]: "Automotor",
    [SectionCode.Muebles]: "Muebles",
    [SectionCode.Pinturas]: "Pinturas",
    [SectionCode.Flooring]: "Flooring",
    [SectionCode.Iluminacion]: "Iluminación",
    [SectionCode.Electricidad]: "Electricidad",
    [SectionCode.JardinYMascotas]: "Jardín y Mascotas",
    [SectionCode.PuertasYVentanas]: "Puertas y Ventanas",
    [SectionCode.Maderas]: "Maderas",
    [SectionCode.Plomeria]: "Plomería",
    [SectionCode.OrganizacionYLimpieza]: "Organización y Limpieza",
    [SectionCode.AmpolletasYTubos]: "Ampolletas y Tubos",
};

export const getSectionDescription = (code: string | number, description?: string): string => {
    if (description && description.trim().length > 0) {
        return description;
    }
    const cleanCode = String(code).replace(/^0+/, '').trim();
    return SECTION_NAMES[cleanCode] || `Sección ${cleanCode}`;
};
